<template>
    <div class="row">
        <div v-for="(index, i) in getDiagramCount.length" :key="i" class="col-md-6">
            <apexchart type="radar"  width="700" :options="chartOptions(i)" :series="series(i)"></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {Money} from './../../../services/Money.js'

export default {
    name: "RadarMultiSeriesMulti",
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        chartData: {
            type: Object
        },
        documents: {
            type: Array
        },
        analyzeType: {
            type: String,
        },
        analyzeLevel: {
            type: Object
        },
        currency: {
            type: String
        },
    },
    data() {
        return {
            money: new Money(),
            colors:['#008000', '#FF0000', '#0000FF', '#FFFF00', '#800000', '#FF8C00', '#800080', '#FF00FF', '#808080', '#00FFFF', '#00FF00', '#FF1493', '#DEB887', '#FFD700', '#FFC0CB', '#90EE90', '#BC8F8F', '#00BFFF', '#7B68EE', '#4682B4', '#ADFF2F', '#808000', '#008080', '#DCDCDC', '#8B4513', '#2F4F4F', '#B8860B', '#EEE8AA', '#DC143C', '#FA8072']
        }
    },
    computed:{

        getDiagramCount(){
            let categories = [];
            if(this.chartData.crit_1 != 'date_item_name' || this.chartData.crit_1 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                categories = [...new Set(this.documents.map((item) => item[this.chartData.crit_1]))];
                categories =  categories.filter(obj => obj !== 'REST');
                categories.sort((a, b) => {
                    const aOrder = this.documents.find(obj => obj[this.chartData.crit_1] === a)[this.chartData.crit_1.replace('_name', '_order')];
                    const bOrder = this.documents.find(obj => obj[this.chartData.crit_1] === b)[this.chartData.crit_1.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
            }
            else{
                const dateValues = this.documents.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                categories = monthsBetween;
            }
            return categories

        }
    },
    methods: {
        chartOptions(i){
            const self = this;
            return {
                chart: {

                    height: 350,
                    type: 'radar',
                    dropShadow: {
                        enabled: true,
                        blur: 1,
                        left: 1,
                        top: 1
                    },
                    defaultLocale: 'pl',
                    locales: [{
                        name: 'pl',
                        options: {
                            toolbar: {
                                exportToSVG:$.i18n._('chart_export_SVG'),
                                exportToPNG:$.i18n._('chart_export_PNG') ,
                                exportToCSV:$.i18n._('chart_export_CSV'),
                                zoomIn:$.i18n._('chart_zoom_in'),
                                zoomOut:$.i18n._('chart_zoom_out'),
                                pan:$.i18n._('chart_pan'),
                                reset:$.i18n._('chart_reset'),
                            }
                        }
                    }],
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none' // Wyłącza przezroczystość na hover
                        }
                    }
                },
                title: {
                    text: self.getTitle(i),
                    align: 'left'
                },
                subtitle: {
                    text: this.getDiagramCount[i],
                    align: 'left'
                },
                stroke: {
                    width: 2
                },
                fill: {
                    opacity: 0.1
                },
                markers: {
                    size: 0
                },
                xaxis: {
                    categories: this.generateCategories(this.documents, this.chartData.crit_3, this.chartData.crit_2, false)
                },

                colors:this.colors,
                yaxis: {
                    title: {
                        text: this.__("net_value_in_base_currency"),
                        style: {
                            fontSize: '9px',
                        }
                    },
                    min: 0, // Minimalna wartość na osi Y
                    max: this.getMax(), // Maksymalna wartość na osi Y
                    forceNiceScale:true,
                    labels: {
                        formatter: function (val) {
                            return self.money.localizeWithInt(val);
                        },
                    },
                },
            }
        },
        roundToNextTen(value) {
            // Zaokrąglanie w górę do najbliższej potęgi 10
            return Math.ceil(value / 10) * 10;
        },

        formatWithZeros(value) {
            // Formatowanie wartości z zerami
            return value.toFixed(0);
        },

        getMax() {
            let max = Number.NEGATIVE_INFINITY;
            for(let i=0;i<this.getDiagramCount.length;i++){
                for (const obj of this.generateChartData(this.documents, this.chartData.crit_2,this.chartData.crit_3, true, this.chartData.crit_1, this.getDiagramCount[i])) {
                    const maxValueInSeries = Math.max(...obj.data);
                    // Zaokrąglenie wartości do najbliżej większej potęgi 10
                    const roundedValue = this.roundToNextTen(maxValueInSeries);
                    // Formatowanie wartości z zerami
                    const formattedValue = parseFloat(this.formatWithZeros(roundedValue));
                    if (formattedValue > max) {
                        max = formattedValue;
                    }
                }
            }
            return parseFloat(max);
        },
        getTitle(i) {
            let transPart = this.chartData.crit_1;
            if(transPart == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                transPart = 'years';
            }
            let transPart2 = this.chartData.crit_3;
            if(transPart2 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                transPart2 = 'years';
            }
            if (this.analyzeType == 'sell') {
                return this.__("analyze_sell_part") + ' ' + this.__(transPart) +  " " + this.__('and') + " " + this.__(transPart2)
            } else {
                return this.__("analyze_buy_part") + ' ' + this.__(transPart) +  " " + this.__('and') + " " + this.__(transPart2)

            }
        },
        series(i) {
            let categories = this.getDiagramCount
            return this.generateChartData(this.documents, this.chartData.crit_3,this.chartData.crit_2, true, this.chartData.crit_1, categories[i]);
        },
        getRandomColor() {
            const r = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
            const g = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
            const b = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
            return `#${r}${g}${b}`;
        },
        generateUniqueColors() {
            const uniqueColors = [];

            return this.getRandomColor();
        },
        generateChartData(data, param2, param3, series = true, crit1, crit1Value = null) {
            let uniqueKeys = [...new Set(data.map((item) => item[param2]))];
            uniqueKeys =  uniqueKeys.filter(obj => obj !== 'REST');
            if(param2 == 'date_item_name' && this.analyzeLevel.date_segregation == 'month'){
                const dateValues = data.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);

                }
                uniqueKeys = monthsBetween;
            }
            let categories = [];
            if (param3 != 'date_item_name' || (param3 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year') ) {
                categories = [...new Set(data.map((item) => item[param3]))].sort((a, b) => {
                    const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                    const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
                categories =  categories.filter(obj => obj !== 'REST');
            } else {
                const dateValues = data.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                categories = monthsBetween;
            }

            const seriesData = [];
            uniqueKeys.sort((a, b) => {

                const aObject = data.find(obj => obj[param2] === a);
                const bObject = data.find(obj => obj[param2] === b);
                if (aObject && bObject) {
                    const aOrder = aObject[param2.replace('_name', '_order')];
                    const bOrder = bObject[param2.replace('_name', '_order')];
                    return aOrder - bOrder;
                } else {
                    return 0; // Lub inna wartość domyślna, zależnie od wymagań
                }
            });
            uniqueKeys.forEach((key) => {
                const dataSeries = categories.map((category) => {
                    const matchingItems = data.filter(
                        (item) => item[param2] === key && item[param3] === category  && (crit1 != null && crit1Value != null ? item[crit1] == crit1Value : true)
                    )
                    return parseFloat(matchingItems.reduce((sum, item) => sum + item.net_in_base_currency, 0));
                });

                const series = {
                    name: key,
                    data: dataSeries,
                };
                seriesData.push(series);
            });
            if (series) {
                return seriesData;
            }
            if (!series) {
                if(param3 != 'date_item_name'){
                    categories.sort((a, b) => {
                        const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                        const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                        return aOrder - bOrder;
                    });
                }

                return categories;
            }
        },
        generateCategories(data, param2, param3, series = true) {
            let uniqueKeys = [...new Set(data.map((item) => item[param2]))];
            uniqueKeys =  uniqueKeys.filter(obj => obj !== 'REST');
            let categories = [];
            if (param3 != 'date_item_name' || (param3 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year') ) {
                categories = [...new Set(data.map((item) => item[param3]))];
                categories =  categories.filter(obj => obj !== 'REST');
                categories.sort((a, b) => {
                    const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                    const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
            } else {
                const dateValues = data.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                categories = monthsBetween;
            }

            const seriesData = [];
            uniqueKeys.sort((a, b) => {

                const aObject = data.find(obj => obj[param2] === a);
                const bObject = data.find(obj => obj[param2] === b);
                if (aObject && bObject) {
                    const aOrder = aObject[param2.replace('_name', '_order')];
                    const bOrder = bObject[param2.replace('_name', '_order')];
                    return aOrder - bOrder;
                } else {
                    return 0; // Lub inna wartość domyślna, zależnie od wymagań
                }
            });
            uniqueKeys.forEach((key) => {
                const dataSeries = categories.map((category) => {
                    const matchingItems = data.filter(
                        (item) => item[param2] === key && item[param3] === category
                    );
                    return parseFloat(matchingItems.reduce((sum, item) => sum + item.net_in_base_currency, 0));
                });

                const series = {
                    name: key,
                    data: dataSeries,
                };
                seriesData.push(series);
            });
            if (series) {
                return seriesData;
            }
            if (!series) {
                if(param3 != 'date_item_name'){
                    categories.sort((a, b) => {
                        const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                        const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                        return aOrder - bOrder;
                    });
                }
                return categories.filter(obj => obj !== 'REST');
            }
        },
    }
}
</script>

<style scoped>

</style>
